import styled from 'styled-components';

export const Container = styled.div`
  font-family: 'Sora', sans-serif;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 30px;

  > div {
    h1 {
      font-weight: 700;
      color: #101d40;
      font-size: 28px;
      letter-spacing: 0px;
    }

    h3 {
      font-weight: 400;
      padding-top: 5px;
      color: #9e9e9e;
      font-size: 16px;
    }
  }

  > span {
    color: #25396f;

    strong {
      font-weight: 700;
    }
  }

  @media only screen and (max-width: 992px) {
    flex-direction: column;
    justify-content: center;
    text-align: center;

    > span {
      padding-top: 20px;
    }
  }

  .title {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    p {
      color: #7c8db5;
      font-size: 16px;
      font-weight: 400;

      span {
        color: #000;
        font-weight: 600;
      }
    }

    @media (min-width: 768px) {
      justify-content: space-between;
      flex-direction: row;
    }
  }
`;
